"use client";
import {useFrontendConfiguratorContext} from "../ProductConfigurator/context";
import {useRouter} from "next/navigation";
import React, {Suspense, useEffect, useState} from "react";
import {useCommerceContext} from "provider/magento/context";

import {useLayoutContext} from "../context";


import {usePhrase} from "app/i18n";
import Button from "app/components/Button/Button";
import ShoppingCartIcon from "@heroicons/react/16/solid/ShoppingCartIcon";
import ArrowRightIcon from "@heroicons/react/16/solid/ArrowRightIcon";
import LockClosedIcon from "@heroicons/react/24/outline/LockClosedIcon";

import ProductBuyBox from "../ProductBuyBox/ProductBuyBox";


import Script from "next/script";

import ProductShippingBox from "../ProductShippingBox/ProductShippingBox";
import {formatCurrencySymbol, formatPriceStyle, roundPrice} from "../../utilities/price";
import ProductInfo from "../ProductInfo/ProductInfo";
import {sendGTMEvent} from "@next/third-parties/google";
import {trackPixelAddToCart} from "../../actions";
import {pixelEvent} from "../FBPixel/pixel";

import FutureProductConfigurator  from "../FutureProductConfigurator/FutureProductConfigurator";

const ProductConfigureBuy = ({product, config, storeCode, takeMeasuresLink = null, _t}) => {
    const t = usePhrase(_t);


    const router = useRouter();

    //const itemId = router?.query?.itemId || null;


    const storeLocale = config.store.locale.replace('_', '-');


    const [quantity, setQuantity] = useState(1);
    const [buyInProgress, setBuyInProgress] = useState(false);
    const {currentConfiguration, setup, itemId} = useFrontendConfiguratorContext();
    const {isLoadingCart, addItem, updateItem, removeCart} = useCommerceContext();
    const {openSidebar} = useLayoutContext();

    const [showErrors, setShowErrors] = useState(false);

    const [basePrice, setBasePrice] = useState(0);

    const [retry, setRetry] = useState(0);


    useEffect(() => {
        if (!product) return;

        let _basePrice = product.price;

        if (product.promo && product.promo > 0)
            _basePrice = _basePrice - parseFloat(basePrice * parseFloat(product.promo / 100))
        if (product.tax && product.promo > 0)
            _basePrice = _basePrice + parseFloat(basePrice * parseFloat(product.tax / 100))

        setBasePrice(parseFloat(_basePrice).toFixed(2));

    }, [product]);


    useEffect(() => {
        if (setup?.quantity)
            setQuantity(setup?.quantity || 1);
    }, [setup?.quantity]);


    const handleAddToCart = async (fastBuy = false) => {

        if (isLoadingCart) return console.log('cart is not available');

        let selOptions = [];
        if (currentConfiguration) {

            if (currentConfiguration.errors && currentConfiguration.errors.length > 0) {


                setShowErrors(true);


                const element = document.getElementById('future-product-conf-anchor');
                if (element) {
                    // 👇 Will scroll smoothly to the top of the next section
                    element.scrollIntoView({block: 'start', behavior: 'smooth'});
                }


                return;
            }


            selOptions = currentConfiguration.options.map(o => ({
                option_id: o.option_id,
                value: o.value.option_type_id ? o.value.option_type_id : o.value
            }));
        }

        setBuyInProgress(true);

        if (!fastBuy) openSidebar();

        addItem(product.sku, quantity, selOptions).then(res => {

            setBuyInProgress(false);

            if (product && currentConfiguration && config.store) {

                let convValue = +parseFloat(currentConfiguration.finalPrice).toFixed(2);

                // calculate promo
                if (setup.product.rules && setup.product.rules.length > 0) {
                    setup.product.rules.map(p => {
                        convValue = roundPrice(convValue - convValue * (p / 100));

                    });
                }

                console.log('convValue', convValue);
                console.log('promo', setup?.product?.promo / 100);

                sendGTMEvent({
                    event: 'add_to_cart',
                    ecommerce: {
                        currency: config.store.base_currency_code,
                        value: +parseFloat(convValue * parseFloat(quantity)).toFixed(2),
                        items: [
                            {
                                item_id: product.sku,
                                item_name: product.name,
                                price: convValue,
                                item_brand: 'NoFlyStore',
                                quantity: quantity
                            }
                        ]
                    }
                });

               trackPixelAddToCart(product.sku, +parseFloat(convValue * parseFloat(quantity)).toFixed(2), quantity, config?.store?.base_currency_code || 'eur').then(infoRes => {
                    pixelEvent('AddToCart', infoRes);
                });

                //console.log(window.dataLayer);
            }

            // console.log('Articolo aggiunto');
            //console.log(res);

            if (fastBuy) {
                router.push(`${config.store?.secure_base_link_url}checkout/onepage`);
            }


        }).catch(reason => {

            console.log(reason);
            if (reason?.parameters) {
                if (reason.parameters?.fieldName === 'cartId') {
                    //try to recover
                    removeCart();
                    setRetry(retry + 1);
                    console.log('retry', retry);
                    if (retry < 2) {
                        removeCart();
                        handleAddToCart(fastBuy);
                    } else {
                        setBuyInProgress(false);

                    }
                    //router.push(`${store?.secure_base_link_url}`);
                    //handleBuy();
                }
            } else {
                setBuyInProgress(false);

            }
            //console.log(reason);
        });

    };

    const handleUpdateCartItem = async () => {

        if (isLoadingCart) return console.log('cart is not available');

        let selOptions = [];
        if (currentConfiguration) {

            if (currentConfiguration.errors && currentConfiguration.errors.length > 0)
                return setShowErrors(true);


            selOptions = currentConfiguration.options.map(o => ({
                option_id: o.option_id,
                value: o.value.option_type_id ? o.value.option_type_id : o.value
            }));
        }

        setBuyInProgress(true);


        updateItem(itemId, quantity, selOptions).then(res => {


            setBuyInProgress(false);

            console.log('Articolo modificato');
            console.log(res);


            router.push(`${config.store?.secure_base_link_url}checkout/cart`);


        }).catch(reason => {
            setBuyInProgress(false);
            console.log(reason);
        });

    };

    return <>
        <div className='w-full grow-0 lg:grow lg:w-auto'>
            <div className={'px-2  mt-3 md:mt-0'}>

                <ProductInfo
                    product={product}
                    storeCode={storeCode}
                    config={config}
                    takeMeasuresLink={takeMeasuresLink}
                    _t={_t}
                />

                <div className={'my-1 min-h-[600px]'}>

                    <Suspense>
                        <FutureProductConfigurator product={product}
                                                   storeCode={storeCode}
                                                   currency={config.store?.default_display_currency_code}
                                                   showErrors={showErrors}
                                                   _t={_t}
                        />
                    </Suspense>

                </div>


                <div className={'block xl:hidden'}>
                    {currentConfiguration && !isNaN(currentConfiguration.finalPriceGrandTotal) && currentConfiguration.finalPriceGrandTotal > 0 &&
                        <div className={'mb-5'}>
                            <span className={'mr-3 text-base font-bold'}>{t('Quantity:')}</span>
                            <div>
                                <input type="number" aria-label={t('Quantity')} value={quantity}
                                       onChange={e => setQuantity(e.target.value)}
                                       className={'w-16 h-8 border-2 border-gray-500 rounded'}/>
                            </div>
                        </div>}

                    <div className={'mb-1'}>
                        <span className={'text-green-700 text-lg font-bold'}>{t('Product available')}</span>
                    </div>

                    <div className={'mb-3'}>
                        <ProductShippingBox product={product} storeCode={storeCode} storeLocale={storeLocale}
                                            light={true} _t={_t}/>
                    </div>

                    {currentConfiguration && !isNaN(currentConfiguration.finalPriceGrandTotal) && currentConfiguration.finalPriceGrandTotal > 0 &&
                        <div className={'mb-1 text-lg'}>
                            <p>{t('Total')}</p>
                            <div>

                                <span id={'product_total_price'}
                                      className={'block font-bold text-4xl'}>
                                    {formatPriceStyle(parseFloat(currentConfiguration?.finalPriceGrandTotal).toFixed(2), true)}
                                    <span
                                        className={`ml-1`}>{formatCurrencySymbol(config.store?.default_display_currency_code, true)}</span></span>
                                {(!config?.customs_info || !config?.customs_info?.enable_table) &&
                                    <span className={'text-[#555] text-md lg:text-xs'}>{t('tax included')}</span>}

                            </div>
                        </div>}

                    <div className={'text-md mb-2'}>
                        {config.payment_methods && ['scalapay', 'paylater', 'payin3', 'payin4'].some(m => config.payment_methods.includes(m)) && currentConfiguration && !isNaN(currentConfiguration.finalPriceGrandTotal) && <>
                            <Script src={'https://cdn.scalapay.com/widget/v3/js/scalapay-widget.esm.js'} type={'module'}
                                    strategy={'lazyOnload'}/>
                            <Script src={'https://cdn.scalapay.com/widget/v3/js/scalapay-widget.js'} noModule
                                    strategy={'lazyOnload'}/>
                            <scalapay-widget
                                frequency-number='30'
                                number-of-installments='3'
                                hide='false'
                                hide-price='false'
                                min='5'
                                max='1500'
                                amount-selectors='["#product_total_price"]'
                                currency-position='after'
                                currency-display='symbol'
                                logo-size='90'
                                theme='primary'
                                locale={storeLocale.substr(0, 2)}
                                show-title='true'
                            ></scalapay-widget>
                        </>}
                    </div>


                    <div className={'flex flex-col mb-5'}>

                        <Button
                            id={'add_to_cart_button'}
                            aria-label={t('Add to cart')}
                            className={`${(isLoadingCart || !setup || buyInProgress) ? 'disabled' : ''} bg-[#e7bb43] py-3 px-4 rounded text-center mb-2`}
                            disabled={isLoadingCart || !setup || buyInProgress}
                            onClick={() => itemId ? handleUpdateCartItem() : handleAddToCart(false)}>
                            <span>{itemId ? t('Update product') : t('Add to cart')}</span>
                            <span className={'absolute right-2'}>

                                        {buyInProgress ? <svg className="animate-spin text-black fill-white h-5 w-5"
                                                              viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                                    strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor"
                                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg> : <ShoppingCartIcon className={'w-6 h-6'}/>}

                                    </span>

                        </Button>

                        {!itemId && <Button className={'!bg-[#111213] !border-[#111213] py-3 px-4 rounded text-center'}
                                            disabled={isLoadingCart || !setup || buyInProgress}
                                            onClick={() => handleAddToCart(true)}>
                            <span className={'text-white'}>{t('Buy now')}</span>
                            <span className={'absolute right-2 text-white'}>
                                        {buyInProgress ? <svg className="animate-spin text-black fill-white h-5 w-5"
                                                              viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                                    strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor"
                                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg> : <ArrowRightIcon className={'w-5 h-5 mr-1'}/>}
                                    </span>
                        </Button>}

                        <div className={'flex items-center text-md text-gray-600 mt-2'}>
                            <span><LockClosedIcon className={'w-5 h-5 mr-1'}/></span>
                            <span className={''}>{t('The transaction is safe')}</span>
                        </div>

                    </div>

                </div>


            </div>
        </div>

        <div className='hidden xl:block w-full xl:w-auto xl:min-w-[230px] xl:max-w-[250px] xl:min-h-[220px]'>
            <ProductBuyBox product={product}
                           config={config}
                           storeCode={storeCode}
                           storeLocale={storeLocale}
                           itemId={itemId}
                           quantity={quantity}
                           setQuantity={setQuantity}
                           buyInProgress={buyInProgress}
                           setBuyInProgress={setBuyInProgress}
                           handleUpdateCartItem={handleUpdateCartItem}
                           handleAddToCart={handleAddToCart}
                           _t={_t}
            />
        </div>
    </>

};

export default ProductConfigureBuy;